// Router (vue-router)
// maps URLs to components

import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import Login from '../components/Login.vue'
import DigitekaLogin from '../components/DigitekaLogin.vue'
import MarkersList from '../components/MarkersList.vue'
import Marker from '../components/Marker.vue'
import MarkerEdit from '../components/MarkerEdit.vue'
import IndividualRecords from '../components/individual_records/IndividualRecords.vue'
import UsersList from '../components/user/UsersList.vue'
import UserDetails from '../components/user/UserDetails.vue'
import ConsumerSettings from '../components/settings/ConsumerSettings.vue'
import { store } from '../store'
import AuthByToken from '../components/AuthByToken'
// import { HotModuleReplacementPlugin } from 'webpack'

Vue.use(Router)

// vue-router 3.1+ rejects redundant navigations (e.g. pushing to the route we
// are already on) with a NavigationDuplicated error. Swallow it so it doesn't
// surface as an uncaught promise rejection in the console.
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return err
    return Promise.reject(err)
  })
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return err
    return Promise.reject(err)
  })
}

function managerGuard (to, from, next) {
  if (store.state.is_manager) return next()
  next(false)
}

let managerRoutes = [
  {
    path: '/marker',
    component: MarkersList,
    meta: {
      auth: true
    }
  }, {
    path: '/marker/edit',
    meta: {
      auth: true,
      existingMarker: false
    },
    component: MarkerEdit,
    canReuse: false
  }, {
    path: '/marker/:markerId/edit',
    meta: {
      auth: true,
      existingMarker: true
    },
    component: MarkerEdit,
    canReuse: false
  }, {
    path: '/marker/:markerId',
    name: 'marker',
    meta: {
      auth: true
    },
    component: Marker
  }, {
    path: '/user',
    component: UsersList,
    meta: {
      auth: true
    }
  }, {
    path: '/user/:userId',
    name: 'user',
    component: UserDetails,
    meta: {
      auth: true
    }
  }, {
    path: '/settings',
    component: ConsumerSettings,
    meta: {
      auth: true
    }
  },
]
managerRoutes = managerRoutes.map(route => {
  route.beforeEnter = managerGuard
  return route
})

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/digiteka/login',
      component: DigitekaLogin
    }, {
    //   path: '/individual_records',
    //   component: IndividualRecords,
    //   props: {
    //     showVideosImages: 'all',
    //   },
    //   meta: {
    //     auth: true
    //   }
    // }, {
      path: '/videos/:tab?',
      component: IndividualRecords,
      name: 'videos',
      props: {
        recordType: 'VIDEO',
      },
      meta: {
        auth: true
      }
    }, {
      path: '/images/:tab?',
      component: IndividualRecords,
      name: 'images',
      props: {
        recordType: 'IMAGE',
      },
      meta: {
        auth: true
      }
    }, {
      path: '/auth/:consumer/:token/',
      component: AuthByToken,
      meta: {
        auth: false
      }
    },
    ...managerRoutes,
    {
      path: '*',
      redirect: '/'
    },
  ]
})
